import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { HuonekorttiResponse } from "@/api/models/huonekortti-response"
import { HuonekorttiStatusResponse } from "@/api/models/huonekortti-status-response"
import ComStatusTag from "@/components/common/ComStatusTag.vue"
import { computed, ref } from "vue"
import { huonekorttiListing } from "./huonekortit"
import { Loading } from "@element-plus/icons-vue"
import {
    useHylkaaHuonekortti,
    useHyvaksyHuonekortti,
    useHyvaksytaHuonekortti,
    useJulkaiseHuonekortti,
    usePalautaHyvaksyttyHuonekortti,
} from "@/methods/huonekorttiComposablses"
import { useHuonekorttiHistoria } from "@/methods/huonekorttiHistoriaComposables"


export default /*@__PURE__*/_defineComponent({
  __name: 'ComStatus',
  props: {
    modelValue: {},
    huonekortti: {}
  },
  setup(__props: any) {

const props = __props

const { writableVastuuyksikot, paakayttaja, updateHuonekortit } = huonekorttiListing()

const { julkaiseHuonekortti, loading: julkaiseLoading } = useJulkaiseHuonekortti({
    onSuccess: () => updateHuonekortit(),
    onError: () => {},
    errorMessage: "Julkaisu epäonnistui"
})

const { hylkaaHuonekortti, loading: hylkaaLoading } = useHylkaaHuonekortti({
    onSuccess: () => updateHuonekortit(),
    onError: () => {},
    errorMessage: "Hylkäys epäonnistui"
})

const { hyvaksyHuonekortti, loading: hyvaksyLoading } = useHyvaksyHuonekortti({
    onSuccess: () => updateHuonekortit(),
    onError: () => {},
    errorMessage: "Hyväksyminen epäonnistui"
})

const { hyvaksytaHuonekortti, loading: hyvaksytaLoading } = useHyvaksytaHuonekortti({
    onSuccess: () => updateHuonekortit(),
    onError: () => {},
    errorMessage: "Hyväksyttäväksi lähettäminen epäonnistui"
})

const { palautaHyvaksyttyHuonekortti, loading: palautaHyvaksyttyLoading } = usePalautaHyvaksyttyHuonekortti({
    onSuccess: () => updateHuonekortit(),
    onError: () => {},
    errorMessage: "Palauttaminen epäonnistui"
})

const globalLoading = computed(() =>
    julkaiseLoading.value ||
    hylkaaLoading.value ||
    hyvaksyLoading.value ||
    hyvaksytaLoading.value ||
    palautaHyvaksyttyLoading.value
)

const readOnly = computed(() =>
    !writableVastuuyksikot.value.some(o => o.id === props.huonekortti.vastuuyksikko.id)
)

const shouldFetchHistoria = ref(false)

const huonekorttiId = computed(() =>
    shouldFetchHistoria.value &&
    props.modelValue === HuonekorttiStatusResponse.Hyvaksytty &&
    paakayttaja.value
        ? props.huonekortti.id
        : undefined
)

const { historia, loading: historiaLoading } = useHuonekorttiHistoria(huonekorttiId)

const handleDropdownVisibleChange = (visible: boolean) => {
    if (visible && !shouldFetchHistoria.value &&
        props.modelValue === HuonekorttiStatusResponse.Hyvaksytty &&
        paakayttaja.value) {
        shouldFetchHistoria.value = true
    }
}

const voiPalauttaa = computed(() => {
    if (!historia.value) return false
    const onMuutoksia =
        (historia.value.huonekortti?.length ?? 0) > 0 ||
        (historia.value.nimikkeet?.length ?? 0) > 0 ||
        (historia.value.tilat?.length ?? 0) > 0
    return !onMuutoksia
})

const disableDropdown = computed(() => {
    if (props.modelValue === HuonekorttiStatusResponse.Hyvaksytty 
        && shouldFetchHistoria.value
        && !historiaLoading.value 
        && !voiPalauttaa.value
    ) {
        return true
    }
    return false
})

return (_ctx: any,_cache: any) => {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (!readOnly.value)
    ? (_openBlock(), _createBlock(_component_el_dropdown, {
        key: 0,
        class: "cursor",
        disabled: globalLoading.value || disableDropdown.value,
        onVisibleChange: handleDropdownVisibleChange
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              (__props.modelValue == _unref(HuonekorttiStatusResponse).Tyo)
                ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(julkaiseHuonekortti)(__props.huonekortti.id)))
                  }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode(" Julkaise ", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (__props.modelValue == _unref(HuonekorttiStatusResponse).Julkaistu)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_unref(paakayttaja))
                      ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                          key: 0,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(hyvaksyHuonekortti)(__props.huonekortti.id)))
                        }, {
                          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                            _createTextVNode(" Hyväksy ", -1)
                          ]))]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_el_dropdown_item, {
                          key: 1,
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(hyvaksytaHuonekortti)(__props.huonekortti.id)))
                        }, {
                          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                            _createTextVNode(" Lähetä hyväksyttäväksi ", -1)
                          ]))]),
                          _: 1
                        }))
                  ], 64))
                : _createCommentVNode("", true),
              (__props.modelValue == _unref(HuonekorttiStatusResponse).Odottaa)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (_unref(paakayttaja))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_el_dropdown_item, {
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(hyvaksyHuonekortti)(__props.huonekortti.id)))
                          }, {
                            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                              _createTextVNode("Hyväksy", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_el_dropdown_item, {
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(hylkaaHuonekortti)(__props.huonekortti.id)))
                          }, {
                            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                              _createTextVNode("Hylkää", -1)
                            ]))]),
                            _: 1
                          })
                        ], 64))
                      : (_openBlock(), _createBlock(_component_el_dropdown_item, {
                          key: 1,
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(hylkaaHuonekortti)(__props.huonekortti.id)))
                        }, {
                          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                            _createTextVNode("Peruuta", -1)
                          ]))]),
                          _: 1
                        }))
                  ], 64))
                : _createCommentVNode("", true),
              (__props.modelValue == _unref(HuonekorttiStatusResponse).Hyvaksytty && _unref(paakayttaja))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    (_unref(historiaLoading))
                      ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                          key: 0,
                          disabled: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, { class: "is-loading" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Loading))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : (voiPalauttaa.value)
                        ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                            key: 1,
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(palautaHyvaksyttyHuonekortti)(__props.huonekortti.id)))
                          }, {
                            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                              _createTextVNode(" Palauta ", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(ComStatusTag, {
            status: __props.modelValue,
            loading: globalLoading.value
          }, null, 8, ["status", "loading"])
        ]),
        _: 1
      }, 8, ["disabled"]))
    : (_openBlock(), _createBlock(ComStatusTag, {
        key: 1,
        status: __props.modelValue
      }, null, 8, ["status"]))
}
}

})